const prompt = {
  1: 'Now start with "Basic Food Safety". READ or PLAY instruction. Then use the QUIZ.',
  2: 'Now focus on "Foodborne Illness". READ or PLAY instruction. Then use the QUIZ.',
  3: 'Great progress! Now build your "Food Protection" skills. READ or PLAY instruction. Then use the QUIZ.',
  4: 'Now focus on "Receive & Store". READ or PLAY instruction. Then use the QUIZ.',
  5: 'Great progress! Now build your "Prepare & Serve" skills. READ or PLAY instruction. Then use the QUIZ.',
  6: 'Almost done! Go to "Clean & Sanitize". READ or PLAY instruction. Then use the QUIZ.'
}
export default prompt



// WEBPACK FOOTER //
// ./src/components/views/nextStepPromt.js